import { connect } from 'react-redux';
import { getContentData } from '@olxbr/mojo-jojo/selectors/content';
import { hideExitPopup } from '../actions';
import ConfirmationModal from './ConfirmationModal';
import { getExitPopupData } from '../selectors';

const mapDispatchToProps = { onClose: hideExitPopup };
const mapStateToProps = (state) => {
  const { visible } = getExitPopupData(state);
  const { 'leave-without-buying-modal': modalContent } = getContentData(state).data;
  return ({
    open: visible,
    content: modalContent,
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);
